import { localize } from '../../../util/Localizer'

const createEmptyDrugClaimExpense = () => {
  return {
    serviceDate: '',
    dinNum: '',
    rxNum: '',
    province: null,
    supplyDays: null,
    quantityType: null,
    drugQuantity: '',
    drugCost: 0,
    dispenseFee: 0,
    paidAmount: null,
    paidByOtherAmount: 0
  }
}

const createEmptyDrugClaimExpenseError = () => {
  return {
    serviceDate: '',
    dinNum: '',
    rxNum: '',
    province: '',
    supplyDays: '',
    quantityType: '',
    drugQuantity: '',
    drugCost: '',
    dispenseFee: '',
    paidAmount: '',
    paidByOtherAmount: ''
  }
}

const validateDinNumberForDrugClaimExpense = (expense, error) => {
  const value = expense.dinNum
  const isValid = (typeof value === 'string' && value.length > 0 && value.length <= 8)

  error.dinNum = (isValid) ? '' : localize('pages.SubmitAClaim.Expenses.Drug.dinError')

  return isValid
}

const validateDateForDrugClaimExpense = (expense, error) => {
  // IMPORTANT: The current implementation of validateDateForDrugClaimExpense allows any string
  // of length greater than zero, except for 'N/A'. It should be updated to validate the
  // date string with a regex.
  const value = expense.serviceDate
  const isValid = (typeof value === 'string' && value.length > 0 && value !== 'N/A')

  error.serviceDate = (isValid) ? '' : localize('pages.SubmitAClaim.Expenses.ServiceDateValidation')

  return isValid
}

const validateRxNumberForDrugClaimExpense = (expense, error) => {
  const value = expense.rxNum
  const isValid = (typeof value === 'string' && value.length > 0)

  error.rxNum = (isValid) ? '' : localize('pages.SubmitAClaim.Expenses.Drug.rxNumError')

  return isValid
}

const validateProvinceForDrugClaimExpense = (expense, error) => {
  const value = expense.province
  const isValid = (typeof value === 'object' && value !== null && /^[A-Z]{2}$/.test(value.id))

  error.province = (isValid) ? '' : localize('pages.SubmitAClaim.Expenses.Drug.provinceError')

  return isValid
}

const validateSupplyDaysForDrugClaimExpense = (expense, error) => {
  const value = Number(expense.supplyDays)
  const isValid = (!isNaN(value) && value > 0)

  error.supplyDays = (isValid) ? '' : localize('pages.SubmitAClaim.Expenses.Drug.supplyDaysError')

  return isValid
}

const validateQuantityTypeForDrugClaimExpense = (expense, error) => {
  const value = expense.quantityType
  const isValid = (typeof value === 'object' && value !== null && Object.keys(value).length > 0)

  error.quantityType = (isValid) ? '' : localize('pages.SubmitAClaim.Expenses.Drug.quantityTypeError')

  return isValid
}

const validateQuantityAmountForDrugClaimExpense = (expense, error) => {
  const value = expense.drugQuantity
  const isValid = (typeof value === 'string' && value.length > 0)

  error.drugQuantity = (isValid) ? '' : localize('pages.SubmitAClaim.Expenses.Drug.quantityError')

  return isValid
}

const validateDrugCostForDrugClaimExpense = (expense, error) => {
  const value = Number(expense.drugCost)
  const isWithinLimit = (value <= 10000)
  const isValid = (!isNaN(value) && value > 0 && isWithinLimit)

  error.drugCost = (isValid) ? '' : (isWithinLimit) ? localize('pages.SubmitAClaim.Expenses.Drug.drugCostError') : localize('pages.SubmitAClaim.Expenses.limitError')

  return isValid
}

const validateDrugCostForDrugDispenseFee = (expense, error) => {
  const value = Number(expense.dispenseFee)
  const isWithinLimit = (value <= 10000)
  const isValid = (!isNaN(value) && value > 0 && isWithinLimit)

  error.dispenseFee = (isValid) ? '' : (isWithinLimit) ? localize('pages.SubmitAClaim.Expenses.Drug.drugCostError') : localize('pages.SubmitAClaim.Expenses.limitError')

  return isValid
}

const validateOtherChargesForDrugClaimExpense = (expense, error) => {
  const value = expense.paidByOtherAmount
  const isWithinLimit = (value <= 10000)
  let isValid = true

  if (isNaN(Number(value))) {
    isValid = false
    error.paidByOtherAmount = localize('pages.SubmitAClaim.Expenses.AmountReceivedByOtherValidation')
  } else if (Number(value) >= Number(expense.drugCost) + Number(expense.dispenseFee)) {
    isValid = false
    error.paidByOtherAmount = (isWithinLimit) ? localize('pages.SubmitAClaim.Expenses.cobValidation') : localize('pages.SubmitAClaim.Expenses.limitError')
  } else {
    error.paidByOtherAmount = ''
  }

  return isValid
}

const validateDrugClaimExpense = (expense, error, hasCOB = false) => {
  let isValid = true

  isValid = validateDateForDrugClaimExpense(expense, error) && isValid
  isValid = validateRxNumberForDrugClaimExpense(expense, error) && isValid
  isValid = validateProvinceForDrugClaimExpense(expense, error) && isValid
  isValid = validateSupplyDaysForDrugClaimExpense(expense, error) && isValid
  isValid = validateQuantityTypeForDrugClaimExpense(expense, error) && isValid
  isValid = validateQuantityAmountForDrugClaimExpense(expense, error) && isValid
  isValid = validateDrugCostForDrugClaimExpense(expense, error) && isValid
  isValid = validateDrugCostForDrugDispenseFee(expense, error) && isValid

  if (hasCOB) {
    isValid = validateOtherChargesForDrugClaimExpense(expense, error) && isValid
  }

  return isValid
}

export {
  createEmptyDrugClaimExpense,
  createEmptyDrugClaimExpenseError,
  validateDinNumberForDrugClaimExpense,
  validateDateForDrugClaimExpense,
  validateRxNumberForDrugClaimExpense,
  validateProvinceForDrugClaimExpense,
  validateSupplyDaysForDrugClaimExpense,
  validateQuantityTypeForDrugClaimExpense,
  validateQuantityAmountForDrugClaimExpense,
  validateDrugCostForDrugClaimExpense,
  validateOtherChargesForDrugClaimExpense,
  validateDrugClaimExpense,
  validateDrugCostForDrugDispenseFee
}



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/ManageDrugExpense/functions.js